<template>
    <transition-group
            name="staggered-fade"
            :tag="tag"
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:after-enter="afterEnter"
            v-on:before-leave="beforeLeave"
            v-on:leave="leave"
            v-on:after-leave="afterLeave"
    >
        <slot></slot>
    </transition-group>
</template>

<style lang="scss">
    @import '../../sass/_global_variables.scss';

</style>

<script>
    import Velocity from 'velocity-animate';

    export default{
        props: {
            tag: { default: "div" },
            delay: { default: 100 }
        },

        data: function() {
            return { }
        },

        methods: {
            beforeEnter: function (el) {
                el.style.opacity = 0
                el.style.height = 0
            },

            enter: function (el, done) {
                var delay = el.dataset.index * this.delay;
                var finalHeight = el.style.height;
                setTimeout(function () {
                    Velocity( el, { opacity: 1, height: finalHeight }, { complete: done } )
                }, delay)
            },

            afterEnter: function (el) {
                el.style.height = 'initial';
            },

            beforeLeave: function (el) {

            },

            leave: function (el, done) {
                var delay = el.dataset.index * this.delay;
                setTimeout(function () {
                    Velocity( el, { opacity: 0, height: 0 }, { complete: done } )
                }, delay)
            },

            afterLeave: function (el) {
                el.style.height = 'initial';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// transition-staggered-list.vue?07ffe7f2